import { Markdown } from '@/components/run/markdown';
import { useSmoothText } from '@/lib/use-smooth-text';

/** Markdown whose text glides in at a steady pace while it is being streamed (see useSmoothText). */
export function SmoothMarkdown({ text, live }: { text: string; live: boolean }) {
  return <Markdown text={useSmoothText(text, live)} />;
}
